import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform<T>(items: T[], searchText: string, key?: keyof T): T[] {
    if (!items) return [];
    if (!searchText) return [];

    const lowerSearch = searchText.toLowerCase();

    return items.filter(item => {
      const value = key ? String(item[key]) : String(item);
      return value.toLowerCase().includes(lowerSearch);
    });
  }
}
